<div class="jit">
  <div class="jit-short">{{ shortenTimestamp }}</div>
</div>
